/**
 * dateUtils.js - 날짜/요일 유틸리티
 * utils.js에서 분리됨 (L-4a 리팩터링)
 */

export const translateEnglishDays = (text) => {
   const dayMap = {
      'monday': '월요일',
      'tuesday': '화요일',
      'wednesday': '수요일',
      'thursday': '목요일',
      'friday': '금요일',
      'saturday': '토요일',
      'sunday': '일요일'
   };

   let translatedText = text;
   Object.keys(dayMap).forEach(englishDay => {
      const regex = new RegExp(`\\b${englishDay}\\b`, 'gi');
      translatedText = translatedText.replace(regex, dayMap[englishDay]);
   });

   return translatedText;
};

export const formatDate = (date, format = 'YYYY-MM-DD') => {
   const d = date;
   const year = d.getFullYear();
   const month = String(d.getMonth() + 1).padStart(2, '0');
   const day = String(d.getDate()).padStart(2, '0');
   const hour = String(d.getHours()).padStart(2, '0');
   const minute = String(d.getMinutes()).padStart(2, '0');
   const second = String(d.getSeconds()).padStart(2, '0');

   const dayNames = ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'];
   const dayName = dayNames[d.getDay()];

   switch (format) {
      case 'YYYY-MM-DD dddd':
         return `${year}-${month}-${day} ${dayName}`;
      case 'MM월 DD일':
         return `${month}월 ${day}일`;
      case 'YYYY-MM-DD HH:mm:ss':
         return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
      default:
         return `${year}-${month}-${day}`;
   }
};

export const addDays = (date, days) => {
   const result = new Date(date);
   result.setDate(result.getDate() + days);
   return result;
};

export const addWeeks = (date, weeks) => addDays(date, weeks * 7);

export const startOfWeek = date => {
   const result = new Date(date);
   const day = result.getDay();
   const diff = result.getDate() - day + (day === 0 ? -6 : 1);
   result.setDate(diff);
   result.setHours(0, 0, 0, 0);
   return result;
};

export const endOfWeek = date => {
   const result = startOfWeek(date);
   result.setDate(result.getDate() + 6);
   result.setHours(23, 59, 59, 999);
   return result;
};

export const startOfMonth = date => {
   const result = new Date(date);
   result.setDate(1);
   result.setHours(0, 0, 0, 0);
   return result;
};

export const endOfMonth = date => {
   const result = new Date(date);
   result.setMonth(result.getMonth() + 1);
   result.setDate(0);
   result.setHours(23, 59, 59, 999);
   return result;
};

export const getWeekday = (date, dayOfWeek, weekOffset = 0) => {
   const result = new Date(startOfWeek(date));
   result.setDate(result.getDate() + (dayOfWeek - 1) + weekOffset * 7);
   result.setHours(0, 0, 0, 0);
   return result;
};
